import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokensService {
  tokens: any;

  get accountToken(): string | undefined {
    return this.tokens?.account_token;
  }

  get billingToken(): string | undefined {
    return this.tokens?.billing_token;
  }

  get communicationToken(): string | undefined {
    return this.tokens?.communication_token;
  }

  get memberToken(): string | undefined {
    return this.tokens?.member_token;
  }

  get eventToken(): string | undefined {
    return this.tokens?.event_token;
  }

  get formsToken(): string | undefined {
    return this.tokens?.form_token;
  }

  get utilitiesToken(): string | undefined {
    return this.tokens?.utilities_token;
  }

  get committeeToken(): string | undefined {
    return this.tokens?.committee_token;
  }

  get reportingToken(): string | undefined {
    return this.tokens?.reporting_token;
  }

  get emailToken(): string | undefined {
    return this.tokens?.email_token;
  }

  get beanCounterToken(): string | undefined {
    return this.tokens?.bean_counter_token;
  }

  get stateEducationToken(): string | undefined {
    return this.tokens?.state_education_token;
  }
}
